export const GA_SECTION_NAMES = {
    EPG: 'Programación',
    SERIES: 'Series',
    MOVIES: 'Peliculas',
    SEARCH: 'Buscador'
}